{
  "title": "Reset Your Password",
  "subtitle": "Choose a strong password",
  "newPasswordLabel": "New Password",
  "confirmPasswordLabel": "Confirm Password",
  "resetButton": "Reset Password",
  "resettingButton": "Resetting...",
  "backToLogin": "Back to login",
  "requirementsText": "Must be 8+ characters with uppercase, lowercase, and numbers",
  "strengthLabel": "Strength: {{strength}}",
  "passwordStrength": {
    "tooShort": "Too short",
    "weak": "Weak",
    "fair": "Fair",
    "good": "Good",
    "strong": "Strong"
  },
  "invalidLink": {
    "title": "Invalid reset link",
    "backButton": "Back to login"
  },
  "errors": {
    "tooShort": "Password must be at least 8 characters",
    "needsUppercase": "Password must contain at least one uppercase letter",
    "needsLowercase": "Password must contain at least one lowercase letter",
    "needsNumber": "Password must contain at least one number",
    "noMatch": "Passwords do not match",
    "invalidOrExpired": "Invalid or expired reset link. Please request a new one.",
    "genericError": "An error occurred. Please try again."
  }
}
